import axios from "axios";

const host = () => process.env.REACT_APP_BACKEND_HOST;

/** Agentes del user pool, con su estado de acceso. */
export async function getAgents(token) {
    const response = await axios.get(host() + '/auth/admin/users', {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.data;
}

/**
 * Deja al agente con una contraseña temporal. La contraseña vuelve una sola vez
 * en esta respuesta: no se guarda en ninguna parte y hay que entregarla a mano.
 */
export async function resetPassword(email, token) {
    const response = await axios.post(
        host() + '/auth/admin/reset-password',
        { email },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
}

/**
 * Da de alta un agente. Cognito le envía la invitación con la contraseña
 * temporal por correo, así que no vuelve nada sensible en la respuesta.
 */
export async function createAgent(email, token) {
    const response = await axios.post(
        host() + '/auth/admin/users',
        { email },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
}

/**
 * Elimina un agente.
 *
 * `confirmEmail` es lo que el administrador tecleó, no una copia del correo de
 * la fila: si se mandara el mismo valor dos veces, la comprobación del servidor
 * sería decorativa y solo quedaría la de la pantalla.
 */
export async function deleteAgent(email, confirmEmail, token) {
    const response = await axios.delete(host() + '/auth/admin/users', {
        headers: { Authorization: `Bearer ${token}` },
        data: { email, confirmEmail },
    });
    return response.data;
}

/** Da permisos de administrador a un agente. */
export async function grantAdmin(email, token) {
    const response = await axios.post(
        host() + '/auth/admin/admins',
        { email },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
}

/**
 * Quita los permisos de administrador. El backend rechaza quitárselos a uno
 * mismo y dejar el pool sin ningún administrador.
 */
export async function revokeAdmin(email, token) {
    const response = await axios.delete(host() + '/auth/admin/admins', {
        headers: { Authorization: `Bearer ${token}` },
        data: { email },
    });
    return response.data;
}
